import { Component, Inject, HostListener, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import {
  AppState,
  ExportActionTypes,
  OrdersActionTypes,
  SearchActionTypes,
  selectUserTheme,
  SortActionTypes,
} from '@app/core/ngrx';

@Component({
  selector: 'ecp-refresh-orders-dialog',
  templateUrl: './refresh-orders-dialog.component.html',
  styleUrls: ['./refresh-orders-dialog.component.scss'],
  standalone: false,
})
export class RefreshOrdersDialogComponent implements OnInit {
  location$: Observable<any>;
  private loadedLocation;
  user$: Observable<any>;
  public loadedUser;
  public currentTime: any;
  public username: string;
  public theme$: Observable<string>;
  interval: any;
  timeLeft = 30;
  /**
   * constructor
   * @param {MatDialogRef<RefreshOrdersDialogComponent>} dialogRef
   * @param data
   */
  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<RefreshOrdersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.theme$ = this.store.pipe(select(selectUserTheme));

    this.location$ = this.store.pipe(select((state) => state.location));
    this.user$ = this.store.pipe(select((state) => state.user));
    this.currentTime = new Date();
    this.location$.subscribe((location) => {
      this.loadedLocation = location.location;
    });
    this.user$.subscribe((user) => {
      this.loadedUser = user.profile;
    });
  }

  ngOnInit() {
    this.startTimer();
  }

  /**
   * closeDialog
   */
  @HostListener('document:keydown.escape')
  postponeDialog() {
    this.clearInterval();
    this.dialogRef.close('postpone');
  }

  refreshList() {
    let payload;
    try {
      payload = this.loadedLocation.location
        ? this.loadedLocation.location
        : this.loadedUser.applicationProfiles[0].medLocation;
    } catch (e) {
      payload = this.loadedUser.applicationProfiles[0].medLocation;
    }
    this.store.dispatch({
      type: OrdersActionTypes.LOAD_ORDERS,
      payload: payload,
    });
    this.currentTime = new Date();
    this.store.dispatch({
      type: SortActionTypes.CLEAR_SORT_BY,
    });
    this.store.dispatch({
      type: SearchActionTypes.CLEAR_SEARCH_TERM,
    });
    this.store.dispatch({
      type: ExportActionTypes.CLEAR_EXPORT_BY,
    });
    this.clearInterval();
    this.dialogRef.close(true);
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.refreshList();
        this.clearInterval();
        this.dialogRef.close(true);
      }
    }, 1000);
  }

  clearInterval() {
    clearInterval(this.interval);
  }
}
